import React from 'react'
import { CONTACT_PHONE } from 'apps/fleet-planner/config'

export const DriverOptedOutMessage = () => {
  return (
    <div>
      <span className='b'>Your driver opted out of text notifications.</span> Please ask them to
      text START to {CONTACT_PHONE} so they can start receiving text reminders to update their
      status.
    </div>
  )
}
